import { initializeApp, FirebaseApp } from 'firebase/app';
import { getFirestore, collection, doc, query, orderBy, addDoc, updateDoc , Firestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "...",
  authDomain: "driver-app-converge.firebaseapp.com",
  projectId: "driver-app-converge",
  storageBucket: "...",
  messagingSenderId: "...",
  appId: "...",
};

const appFire: FirebaseApp = initializeApp(firebaseConfig);

const db: Firestore = getFirestore(appFire);
export { db, getFirestore, collection, doc, query, orderBy, addDoc, updateDoc, appFire };